// extracted by mini-css-extract-plugin
module.exports =  {"banner":"_84ff5fbbc9--banner--lzrBj","image":"_84ff5fbbc9--image--awkTW","download-text":"_84ff5fbbc9--download-text--DayXy","link":"_84ff5fbbc9--link--iX_rY"};